import { api, fetcher } from "services/api.service";
import { ActionFunctionArgs, LoaderFunctionArgs } from "react-router-dom";
import { ProductCatalog } from "types/productCatalog";
import { withAuth } from "routes/utils/withAuth";
import { useGlobalAlert } from "hooks/useAlert";
import { AxiosError } from "axios";

export const loader = withAuth(async ({ params, request }: LoaderFunctionArgs) => {
  const { productId } = params;
  const product = await fetcher<ProductCatalog>(`/product_catalogs/${productId}`);

  const url = new URL(request.url);
  const copyFrom = url.searchParams.get("copyFrom");
  if (copyFrom) {
    const copyFromProduct = await fetcher<ProductCatalog>(`/product_catalogs/${copyFrom}`);
    const updatedProduct: ProductCatalog = {
      ...copyFromProduct,
      id: product.id,
      merchantProductNumber: product.merchantProductNumber,
      sku: product.sku,
      deviceType: product.deviceType,
      updatedAt: new Date().toISOString(),
    };
    return { product: updatedProduct };
  } else {
    return { product };
  }
});

export async function action({ params, request }: ActionFunctionArgs) {
  try {
    const fd = await request.formData();
    const res = await api.request({
      method: "PUT",
      url: `/product_catalogs/${params.productId}`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (res.status === 200) {
      useGlobalAlert.alertSuccess("Product catalog updated successfully");
      return new Response(null, { status: 200 });
    }
  } catch (err) {
    const { response } = err as AxiosError;
    useGlobalAlert.alertError(`Error updating product catalog: ${response?.status} - ${response?.statusText}`);
    return null;
  }
}
